import {useIsMobile} from '@hconnect/uikit'
import {Column} from '@hconnect/uikit/src/lib2'
import {Link} from '@mui/material'
import {useTranslation} from 'react-i18next'

import {FEATURE_NAMESPACE} from '../consts'
import {RefLinks} from '../types'

export const useRefLinksColumns = () => {
  const {t} = useTranslation(FEATURE_NAMESPACE)
  const isMobile = useIsMobile()

  const commonColumns: Column<RefLinks>[] = [
    {
      key: 'topicName',
      label: t('referenceLinksPage.table.topicName'),
      columnSx: {
        pl: {xs: 1.5, sm: 2}
      }
    },
    {
      key: 'questionId',
      label: t('referenceLinksPage.table.questionId'),
      columnSx: {
        pl: {xs: 1.5, sm: 2}
      }
    },
    {
      key: 'guidanceLink',
      label: t('referenceLinksPage.table.guidanceLink'),
      columnSx: {
        pl: {xs: 1.5, sm: 2}
      },
      customTemplate: ({guidanceLink}) => (
        <Link
          href={guidanceLink}
          target="_blank"
          rel="noopener noreferrer"
          variant="caption"
          data-test-id="question-ref-link"
          onClick={(e) => e.stopPropagation()}
        >
          {t('referenceLinksPage.table.guidanceLink')}
        </Link>
      )
    }
  ]

  if (!isMobile) {
    commonColumns.unshift({
      key: 'sectionName',
      label: t('referenceLinksPage.table.sectionName'),
      columnSx: {
        pl: {xs: 1.5, sm: 2}
      }
    })
    return commonColumns
  }
  return commonColumns
}
